import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'
import { Box, Button, Typography } from '@mui/material'
import { Settings } from '@mui/icons-material'


const Breadcrumbs = () => {
  
  const { t } = useTranslation()
  const navigate = useNavigate()

  const user = useSelector((state: RootState) => state['user'].user)

  const params = useParams()
  const section = params['*']?.split('/')?.[0]
  
  const setupMap = {
    'accommodations': {title: t('common.accommodations')},
    'modifications': {title: t('common.modifications')},
    'assessment-strategies': {title: t('common.assessment-strategies')},
    'concern-reasons': {title: t('common.concern-reasons')},
    'lesson-plan-options': {title: t('common.lesson-plan-options')},
    'instructional-strategies': {title: t('common.instructional-strategies')},
    'intervention-strategies': {title: t('common.intervention-strategies')},
    'intervention-types': {title: t('common.intervention-types')},
    'plop-categories': {title: t('common.plop-categories')},
    'problem-areas': {title: t('common.problem-areas')},
    'progress-monitoring-tools': {title: t('common.progress-monitoring-tools')},
    'monitoring-methods': {title: t('common.monitoring-methods')},
    'subjects': {title: t('common.subjects')},
    'topics': {title: t('common.topics')},
    'meeting-categories': {title: t('common.meeting-categories')},
    'fluencies': {title: t('common.fluencies')},
    'highlights': {title: t('common.highlights')},
    'assessment-types': {title: t('common.assessment-types')},
    'submission-types': {title: t('common.submission-types')},
    'score-types': {title: t('common.score-types')},
    'courses': {title: t('common.course-planning-panel')},
    'syllabus': {title: t('common.syllabus-panel')},
    'curriculum-map': {title: t('common.curriculum-map')},
    'kpi-tracker': {title: t('common.kpi-tracker')},
    'benchmark-tracker': {title: t('common.benchmark-tracker')},
    'personalized-learning-pathways': {title: t('common.personalized-learning-pathways')},
  }

  const map = {
    'school': {title: t('common.school-details')},
    'staff': {title: t('common.staff')},
    'academic-periods': {title: t('school.academic-periods')},
    'milestones': {title: t('school.academic-calendar')},
    'timetables': {title: t('common.class-schedule')},
    'groups': {title: t('common.groups')},
    'teams': {title: t('common.teams')},
    'group-courses': {title: t('common.group-courses')},
    'sessions': {title: t('common.sessions')},
    'grade-scale': {title: t('school.grading-scale')},
    'grade-levels': {title: t('common.grade-levels')},
    'course-components': {title: t('common.course-components')},
    'rubrics': {title: t('common.rubric')},
    'risk-criteria': {title: t('risk.risk-criteria')},
    'grade-risk-criteria': {title: t('risk.grade-risk-criteria')},
    'attendance': {title: t('common.attendance')},
    'behaviour': {title: t('common.behaviour-incidents')},
    'rti-team': {title: t('common.rti-team')},
    'special-education-team': {title: t('common.special-team')},
  } 


  const urlParts = params['*']?.split('/')
  let title = null
  if(section === 'setup' && urlParts.length > 1){
    const type = urlParts[1]
    title = setupMap[type].title || null
  }else if(map[section]){
    title = map[section].title || null
  }
  
  useEffect(() => {
    if(title){
      const element = document.querySelector(`.breadcrumbs`)
      if (!element) return
      element.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }, [title])


  return (
    ['principal','vice_principal','staff_administrator','teacher','special_teacher'].includes(user?.role) && 
    title && 
    <Box className="breadcrumbs" sx={{ padding: '5px 20px', marginBottom: '20px', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px', background: '#fff' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
          <Settings />
          <Typography sx={{ fontSize: '1rem', fontWeight: '600', marginLeft: '10px' }}>{t('common.setup')} / {title}</Typography>
          <Button
            variant='outlined'
            color='black'
            onClick={() => navigate('/setup')}
            className='small-button'
            sx={{ width: '120px', marginLeft: '20px' }}
           >
            {`${t('common.go-to-setup')}`}
          </Button>
      </div>
    </Box>
  )
}

export default Breadcrumbs
